export class EstadoCivil {
    id = 0;
    estadoCivil = '';
}